import React from 'react';
import './Legal.css';

const TermsOfService = () => {
  return (
    <div className="legal-container">
      <div className="legal-content">
        <h1>Terms of Service</h1>
        <p className="legal-updated">Last updated: June 19, 2026</p>

        <section>
          <h2>Acceptance of Terms</h2>
          <p>
            By accessing or using GetVetBill.com ("VetBill," "we," "us," or "our"), you agree to
            be bound by these Terms of Service. If you do not agree, do not use the service.
          </p>
        </section>

        <section>
          <h2>Description of Service</h2>
          <p>
            VetBill is a community-driven platform that allows users to upload veterinary bills and
            estimates to build a database of veterinary pricing. The platform displays aggregated
            pricing data to help pet owners compare costs across veterinary hospitals.
          </p>
        </section>

        <section>
          <h2>User Accounts</h2>
          <ul>
            <li>You must provide accurate information when creating an account.</li>
            <li>You are responsible for maintaining the security of your account credentials.</li>
            <li>You must be at least 18 years old to create an account.</li>
            <li>We reserve the right to suspend or terminate accounts that violate these terms.</li>
          </ul>
        </section>

        <section>
          <h2>User-Submitted Content</h2>
          <p>By uploading a veterinary bill or estimate, you represent that:</p>
          <ul>
            <li>You are the rightful owner or recipient of the bill.</li>
            <li>The bill is a genuine veterinary document.</li>
            <li>You consent to the extraction and display of anonymized pricing data from the bill.</li>
          </ul>
          <p>
            You retain ownership of your original documents. By uploading, you grant VetBill a
            non-exclusive, royalty-free license to process, store, and display the extracted data
            in aggregated and anonymized form.
          </p>
        </section>

        <section>
          <h2>Prohibited Conduct</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Upload fraudulent, fabricated, or misleading bills</li>
            <li>Upload documents containing other people's personal information without consent</li>
            <li>Attempt to manipulate pricing data or game the system</li>
            <li>Scrape, crawl, or harvest data from VetBill for commercial purposes</li>
            <li>Interfere with or disrupt the service</li>
            <li>Use the service for any unlawful purpose</li>
          </ul>
        </section>

        <section>
          <h2>Pricing Data Disclaimer</h2>
          <p>
            Pricing data displayed on VetBill is based on user-submitted bills and is provided
            for informational purposes only. We do not guarantee the accuracy, completeness, or
            currentness of any pricing data. Actual veterinary costs may vary. VetBill is not a
            substitute for professional veterinary advice.
          </p>
        </section>

        <section>
          <h2>Limitation of Liability</h2>
          <p>
            VetBill is provided "as is" without warranties of any kind. To the fullest extent
            permitted by law, VetBill shall not be liable for any indirect, incidental, special,
            or consequential damages arising from your use of the service.
          </p>
        </section>

        <section>
          <h2>Intellectual Property</h2>
          <p>
            The VetBill name, logo, and website design are the property of VetBill. You may not
            use our branding without prior written permission.
          </p>
        </section>

        <section>
          <h2>Changes to Terms</h2>
          <p>
            We may update these Terms of Service at any time. Continued use of VetBill after
            changes constitutes acceptance of the revised terms. We will notify users of
            significant changes by posting the updated terms on this page.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>If you have questions about these Terms of Service, contact us at <a href="mailto:support@getvetbill.com">support@getvetbill.com</a>.</p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;
